<template>
	<div class="foldable-container" :class="{ folded: folded, foldable: showHeader }">
		<div v-if="showHeader" class="fc-header" :style="{ background: headerBackground }" @click="toggleFold">
			<slot name="header" />
			<span class="fc-fold-arrow">
				<span class="material-icons">arrow_drop_down</span>
			</span>
		</div>
		<div class="fc-content" ref="content">
			<slot name="content" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'foldable-container',
	props: {
		showHeader: {
			type: Boolean,
			default: true
		},
		headerBackground: String
	},
	data() {
		return {
			folded: this.showHeader
		};
	},
	mounted() {
		this.refreshHeight();
	},
	methods: {
		toggleFold() {
			this.folded = !this.folded;
			this.refreshHeight();
			this.$emit('fold-state-changed', this.folded);
		},
		fold() {
			this.folded = true;
			this.refreshHeight();
			this.$emit('fold-state-changed', true);
		},
		refreshHeight() {
			const el = this.$refs.content;
			if (this.folded) {
				el.style.display = 'none';
				el.style.maxHeight = null;
			} else {
				el.style.display = null;
				el.style.maxHeight = `${el.scrollHeight}px`;
			}
		}
	}
};
</script>

<style lang="scss">
.foldable-container {
	overflow: hidden;
	border-radius: 10px;
	background: #424242;
	border: 1px solid #fff3;
	.fc-header {
		position: relative;
    background: #0004;
		padding: 0 44px;
    box-shadow: #0039 0 0px 10px;
		pointer-events: none;
		.fc-fold-arrow {
			position: absolute;
			right: 10px;
			transform: translateY(-50%);
			height: 24px;
			top: 50%;
			>span {
				transition: transform 150ms ease;
				transform: rotate(0deg);
			}
		}
	}
	&.folded {
		.fc-fold-arrow {
			>span {
				transform: rotate(180deg);
			}
		}
	}
	&.foldable {
		.fc-header {
			pointer-events: inherit;
		}
		.fc-content {
			transition: max-height ease-out 150ms;
			max-height: 0;
		}
	}
}
</style>
